import { AfterContentInit, Component, OnInit } from '@angular/core';
import { SubtitlesService, ViewsService, TimeDateService } from "../core";
import { AlarmHistoryService } from "../core/alarm-history.service";

@Component({
  selector: 'app-alarm-history',
  templateUrl: './alarm-history.component.html',
  styleUrls: ['./alarm-history.component.scss'],
})
export class AlarmHistoryComponent implements OnInit, AfterContentInit {

  constructor(
      public subtitles: SubtitlesService,
      public timeDate: TimeDateService,
      public alarmHistory: AlarmHistoryService,
      public views: ViewsService
  ) {}

  ngOnInit() {
    this.initializeDates();
    this.getAlarmHistory();

  }
  ngAfterContentInit(){
    this.views.setAlarmHistoryHeights();
  }
  setDate(date: string, dateRange: string) {
    if (dateRange === 'fromDate') {
      this.alarmHistory.fromDate = date;
    } else if (dateRange === 'toDate') {
      this.alarmHistory.toDate = date;
    }
    this.timeDate.date = date;
  }

  onSearchTextChange(): void {
    this.alarmHistory.searchText();
  }

  private initializeDates(): void {
    const now = new Date();
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 92);

    this.alarmHistory.type = 'all';
    this.alarmHistory.fromDate = this.formatDate(fromDate);
    this.alarmHistory.toDate = this.formatDate(now);
    this.alarmHistory.showFromDatePicker = false;
    this.alarmHistory.showToDatePicker = false;
  }

  private formatDate(date: Date): string {
    return `${date.getFullYear()}-${this.timeDate.double(date.getMonth() + 1)}-${this.timeDate.double(date.getDate())}`;
  }

  private getAlarmHistory(): void {
    this.alarmHistory.getAlarmHistory();
  }
}